import { FC, ReactElement } from "react";
import { styled } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";

import { getInitialsFromName } from "core/utils/str";

interface Props {
  children?: ReactElement<any, any> | string;
  disableTooltip?: boolean;
  name?: string;
  toolTip?: string;
  useAvatar?: boolean;
}

export const UserAvatar: FC<Props> = ({
  children,
  disableTooltip,
  name,
  toolTip,
  useAvatar
}): JSX.Element | null => {
  if (useAvatar === false) {
    return null;
  }

  const title = disableTooltip ? "" : toolTip ?? name;

  return (
    <>
      <Tooltip title={title}>
        {name === "Unassigned" ? (
          <UnassignedAvatar data-testid="avatar-unassigned">
            Un
          </UnassignedAvatar>
        ) : (
          <PrimaryAvatar data-testid="avatar-assigned">
            {getInitialsFromName(children ?? name)}
          </PrimaryAvatar>
        )}
      </Tooltip>
    </>
  );
};

const PrimaryAvatar = styled(Avatar)`
  background-color: ${props => props.theme.palette.primary.main};
  color: ${props =>
    props.theme.palette.getContrastText(props.theme.palette.primary.main)};
`;

const UnassignedAvatar = styled(Avatar)`
  background-color: ${props => props.theme.palette.grey["400"]};
  color: ${props =>
    props.theme.palette.getContrastText(props.theme.palette.primary.main)};
`;
